export const blockIconsSocialSentimentVerySatisfiedNew = (
	<span className='material-symbols-outlined'>sentiment_very_satisfied</span>
);
